import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FullNameProps } from "../types";

/**
 * Displays an employee's full name as a clickable link to their profile
 * @param props - Component props
 * @param props.record - Record containing employee data
 * @returns Link component with employee's full name
 */
const FullName: React.FC<FullNameProps> = ({ record }) => {
  const location = useLocation();

  // Construct base path by removing the last segment of the current URL
  const branchPath = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );

  // Generate employee profile URL and full name
  const profileUrl = record?.employee?.id
    ? `${branchPath}/employees/${record.employee.id}`
    : "#"; // Fallback to non-navigating link if no ID

  const fullName = record?.employee
    ? `${record.employee.surename || ""} ${
        record.employee.first_name || ""
      }`.trim()
    : "";

  // Link styles
  const linkStyle: React.CSSProperties = {
    color: "inherit",
    textDecoration: "underline",
  };

  return (
    <Link style={linkStyle} to={profileUrl}>
      <div className="content">{fullName}</div>
    </Link>
  );
};

export default FullName;
